import { render } from "./sampleToggle.vue?vue&type=template&id=7b9612d1&scoped=true"
import script from "./sampleToggle.vue?vue&type=script&lang=js"
export * from "./sampleToggle.vue?vue&type=script&lang=js"

import "./sampleToggle.vue?vue&type=style&index=0&id=7b9612d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9612d1"]])

export default __exports__